var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    [
      _vm.checkbox
        ? _c("td", [
            _c(
              "div",
              {
                staticClass:
                  "v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light",
                attrs: { primary: "" },
              },
              [
                _c("div", { staticClass: "v-input__control" }, [
                  _c(
                    "div",
                    { staticClass: "v-input__slot" },
                    [_c("v-checkbox")],
                    1
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.headers, function (header, j) {
        return _c("td", { key: `td-row_${_vm.index}-col_${j}` }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.accessItemValue(header, _vm.row.data)) +
              "\n    "
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }